import {State} from '../types'

export const ticketDescriptionExpanded = (state: State, ticketDefId: string) =>
  Boolean(state.ticketsPicker.tickets?.[ticketDefId]?.expandedDescription)
